import React from "react";
import ItemDetailsFooter from "./item-details-footer";

const ItemDetailsUser = ({ itemInfo }) => {
  const text = itemInfo.store
    ? "Download the app to check-in to this business."
    : "Download the app to add this user as a friend.";
  return (
    <div className="item-details-body-container">
      <p className="home-logo-container">
        <img src={require("../../../assets/images/logo.png")} alt="logo" />
      </p>

      <div className="item-details-user-container">
        <img
          src={itemInfo.avatar}
          alt="user"
          className="item-details-user-avatar"
        />

        <div className="item-details-user-container-info">
          <p>{itemInfo.name}</p>
          <p>{itemInfo.store ? "Business" : "Individual"} Account</p>
        </div>
      </div>

      <ItemDetailsFooter text={text} />
    </div>
  );
};

export default ItemDetailsUser;
